import { FieldProps } from '@fluentui/react-components';
import { FieldErrors, FieldValues } from 'react-hook-form';

export function getValidationState<TFieldValues extends FieldValues>(
  name: string,
  formErrors: FieldErrors<TFieldValues>,
): Pick<FieldProps, 'validationMessage' | 'validationState'> {
  const error = formErrors[name];
  return {
    validationState: error ? 'error' : 'none',
    validationMessage: error?.message?.toString() ?? '',
  };
}
